import React, { useMemo } from 'react';
import { Card, Button, Badge } from '@dopomogai/ui';
import type { InvestOfferingListItem } from '@dopomogai/types';

type Props = {
  item: InvestOfferingListItem;
  onInvest: (agentId: string) => void;
  onView: (agentId: string) => void;
  bonusBadgeText?: string;
};

export function AgentInvestCard({ item, onInvest, onView, bonusBadgeText }: Props) {
  const { agent_id, name, offering, stats } = item;
  const percent = useMemo(() => {
    const p = (stats.sold_shares / Math.max(1, offering.total_shares)) * 100;
    return Math.max(0, Math.min(100, Math.round(p)));
  }, [stats.sold_shares, offering.total_shares]);

  const remaining = Math.max(0, offering.total_shares - stats.sold_shares);
  const active = offering.status === 'active';

  return (
    <Card>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-lg font-extrabold">{name}</div>
          <Badge text={active ? 'Funding' : offering.status} accentColor={active ? 'green' : 'yellow'} />
        </div>
        <div className="flex items-center justify-between text-sm text-slate-600">
          <div>{stats.investor_count} supporters</div>
          {bonusBadgeText && <span className="text-emerald-700 font-semibold">{bonusBadgeText}</span>}
        </div>
        <div className="w-full h-3 bg-slate-200 border-2 border-black rounded-lg overflow-hidden">
          <div className="h-full bg-emerald-400" style={{ width: `${percent}%` }} />
        </div>
        <div className="grid grid-cols-3 gap-2 text-sm">
          <div className="border-2 border-black rounded-lg p-2 bg-white">
            <div className="text-xs text-slate-600">Price</div>
            <div className="font-bold">{offering.price_per_share_credits} cr/unit</div>
          </div>
          <div className="border-2 border-black rounded-lg p-2 bg-white">
            <div className="text-xs text-slate-600">Remaining</div>
            <div className="font-bold">{remaining}</div>
          </div>
          <div className="border-2 border-black rounded-lg p-2 bg-white">
            <div className="text-xs text-slate-600">Round size</div>
            <div className="font-bold">{offering.total_shares}</div>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="secondary" text="View agent" onClick={() => onView(agent_id)} />
          <Button text="Invest" onClick={() => onInvest(agent_id)} disabled={!active} />
        </div>
      </div>
    </Card>
  );
}


